module.exports = __webpack_public_path__ + "static/placeholder-808cc9a9462d40f6e2246badf00d5e48.jpg";